const translation = {
  currentPlan: 'طرح فعلی',
  upgradeBtn: {
    plain: 'ارتقاء طرح',
    encourage: 'هم اکنون ارتقاء دهید',
    encourageShort: 'ارتقاء دهید',
  },
  viewBilling: 'مدیریت صورتحساب‌ها و اشتراک‌ها',
  buyPermissionDeniedTip: 'لطفاً با مدیر سازمان خود تماس بگیرید تا اشتراک تهیه کنید',
  plansCommon: {
    title: 'یک طرح مناسب برای خود انتخاب کنید',
    yearlyTip: 'با اشتراک سالانه 2 ماه رایگان دریافت کنید!',
    mostPopular: 'محبوب‌ترین',
    planRange: {
      monthly: 'ماهانه',
      yearly: 'سالانه',
    },
    month: 'ماه',
    year: 'سال',
    save: 'صرفه‌جویی کنید ',
    free: 'رایگان',
    currentPlan: 'طرح فعلی',
    contractSales: 'تماس با فروش',
    contractOwner: 'تماس با مدیر تیم',
    startForFree: 'رایگان شروع کنید',
    getStartedWith: 'شروع کنید با ',
    contactSales: 'تماس با فروش',
    talkToSales: 'صحبت با فروش',
    modelProviders: 'ارائه‌دهندگان مدل',
    teamMembers: 'اعضای تیم',
    annotationQuota: 'سهمیه حاشیه‌نویسی',
    buildApps: 'ساخت اپلیکیشن‌ها',
    vectorSpace: 'فضای وکتور',
    vectorSpaceBillingTooltip: 'هر 1 مگابایت می‌تواند حدود 1.2 میلیون کاراکتر از داده‌های وکتور شده را ذخیره کند (براساس تخمین با استفاده از OpenAI Embeddings، متفاوت بر اساس مدل‌ها).',
    vectorSpaceTooltip: 'فضای وکتور سیستم حافظه بلند مدت است که برای درک داده‌های شما توسط LLM‌ها مورد نیاز است.',
    documentsUploadQuota: 'سهمیه بارگذاری مستندات',
    documentProcessingPriority: 'اولویت پردازش مستندات',
    documentProcessingPriorityTip: 'برای اولویت پردازش بالاتر مستندات، لطفاً طرح خود را ارتقاء دهید.',
    documentProcessingPriorityUpgrade: 'داده‌های بیشتری را با دقت بالاتر و سرعت بیشتر پردازش کنید.',
    priority: {
      'standard': 'استاندارد',
      'priority': 'اولویت',
      'top-priority': 'اولویت بالا',
    },
    logsHistory: 'تاریخچه گزارشات',
    customTools: 'ابزارهای سفارشی',
    unavailable: 'غیرقابل دسترس',
    days: 'روز',
    unlimited: 'نامحدود',
    support: 'پشتیبانی',
    supportItems: {
      communityForums: 'انجمن‌های اجتماعی',
      emailSupport: 'پشتیبانی ایمیل',
      priorityEmail: 'پشتیبانی ایمیل و چت با اولویت',
      logoChange: 'تغییر لوگو',
      SSOAuthentication: 'تأیید هویت SSO',
      personalizedSupport: 'پشتیبانی شخصی‌سازی شده',
      dedicatedAPISupport: 'پشتیبانی API اختصاصی',
      customIntegration: 'یکپارچه‌سازی و پشتیبانی سفارشی',
      ragAPIRequest: 'درخواست‌های API RAG',
      bulkUpload: 'بارگذاری دسته‌ای مستندات',
      agentMode: 'حالت Agent',
      workflow: 'جریان کار',
      llmLoadingBalancing: 'توزیع بار LLM',
      llmLoadingBalancingTooltip: 'اضافه کردن چندین کلید API به مدل‌ها، به طور مؤثر از محدودیت‌های نرخ API عبور می‌کند.',
    },
    comingSoon: 'به زودی',
    member: 'عضو',
    memberAfter: 'عضو',
    messageRequest: {
      title: 'اعتبارات پیام',
      tooltip: 'سهمیه‌های فراخوانی پیام برای طرح‌های مختلف با استفاده از مدل‌های OpenAI (به جز gpt4). پیام‌های بیش از حد محدودیت از کلید API OpenAI شما استفاده می‌کنند.',
      titlePerMonth: '{{count,number}} پیام در ماه',
    },
    annotatedResponse: {
      title: 'محدودیت‌های سهمیه حاشیه‌نویسی',
      tooltip: 'ویرایش دستی و حاشیه‌نویسی پاسخ‌ها، قابلیت‌های پرسش و پاسخ با کیفیت بالا و قابل تنظیم برای اپلیکیشن‌ها را فراهم می‌کند. (فقط در اپلیکیشن‌های چت اعمال می‌شود)',
    },
    ragAPIRequestTooltip: 'به تعداد درخواست‌های API که فقط قابلیت‌های پردازش پایگاه دانش Dify را فراخوانی می‌کنند اشاره دارد.',
    receiptInfo: 'فقط صاحب تیم و مدیر تیم می‌توانند اشتراک تهیه کنند و اطلاعات صورتحساب را مشاهده کنند',
    apiRateLimitUnit: '{{count,number}}/روز',
    cloud: 'سرویس ابری',
    documents: '{{count,number}} سندهای دانش',
    self: 'خود میزبان',
    apiRateLimit: 'محدودیت نرخ API',
    annualBilling: 'صورتحساب سالانه',
    freeTrialTip: 'آزمایش رایگان ۲۰۰ تماس OpenAI.',
    teamMember_other: '{{count,number}} اعضای تیم',
    unlimitedApiRate: 'هیچ محدودیتی برای نرخ API وجود ندارد.',
    freeTrialTipPrefix: 'ثبت‌نام کنید و یک',
    comparePlanAndFeatures: 'طرح ها و ویژگی ها را مقایسه کنید',
    teamMember_one: '{{count,number}} عضو تیم',
    priceTip: 'برای هر محیط کار/',
    documentsTooltip: 'حجم مستندات وارد شده از منبع داده‌های دانش.',
    freeTrialTipSuffix: 'نیاز به کارت اعتباری نیست',
    teamWorkspace: '{{count,number}} فضاي کار تيمي',
    getStarted: 'شروع کنید',
    documentsRequestQuota: '{{count,number}}/دقیقه محدودیت نرخ درخواست دانش',
    apiRateLimitTooltip: 'محدودیت نرخ API برای همه درخواست‌های انجام شده از طریق API Dify اعمال می‌شود، از جمله تولید متن، محاوره‌های چت، اجرای گردش‌های کار و پردازش اسناد.',
    documentsRequestQuotaTooltip: 'تعیین می‌کند که تعداد کلی اقداماتی که یک فضای کاری می‌تواند در هر دقیقه در داخل پایگاه دانش انجام دهد، شامل ایجاد مجموعه داده، حذف، به‌روزرسانی، بارگذاری مستندات، تغییرات، بایگانی و پرسش از پایگاه دانش است. این معیار برای ارزیابی عملکرد درخواست‌های پایگاه دانش استفاده می‌شود. به عنوان مثال، اگر یک کاربر Sandbox در طی یک دقیقه 10 آزمایش متوالی انجام دهد، فضای کاری او به طور موقت از انجام اقدامات زیر در دقیقه بعدی محدود خواهد شد: ایجاد مجموعه داده، حذف، به‌روزرسانی و بارگذاری یا تغییر مستندات.',
  },
  plans: {
    sandbox: {
      name: 'محیط آزمایشی',
      description: '200 بار آزمایش رایگان GPT',
      includesTitle: 'شامل:',
      for: 'دوره آزمایشی رایگان قابلیت‌های اصلی',
    },
    professional: {
      name: 'حرفه‌ای',
      description: 'برای افراد و تیم‌های کوچک برای باز کردن قدرت بیشتر به طور مقرون به صرفه.',
      includesTitle: 'همه چیز در طرح رایگان، به علاوه:',
      for: 'برای توسعه‌دهندگان مستقل/تیم‌های کوچک',
    },
    team: {
      name: 'تیم',
      description: 'همکاری بدون محدودیت و لذت بردن از عملکرد برتر.',
      includesTitle: 'همه چیز در طرح حرفه‌ای، به علاوه:',
      for: 'برای تیم‌های متوسط',
    },
    enterprise: {
      name: 'سازمانی',
      description: 'دریافت کامل‌ترین قابلیت‌ها و پشتیبانی برای سیستم‌های بزرگ و بحرانی.',
      includesTitle: 'همه چیز در طرح تیم، به علاوه:',
      features: {
        0: 'راهکارهای استقرار مقیاس‌پذیر در سطح سازمانی',
        8: 'پشتیبانی فنی حرفه‌ای',
        3: 'چندین فضای کاری و مدیریت سازمانی',
        5: 'SLA های توافق شده توسط شرکای Dify',
        4: 'SSO',
        2: 'ویژگی‌های انحصاری سازمانی',
        1: 'مجوز صدور مجوز تجاری',
        6: 'امنیت و کنترل‌های پیشرفته',
        7: 'به‌روزرسانی‌ها و نگهداری توسط دیفی به‌طور رسمی',
      },
      price: 'سفارشی',
      btnText: 'تماس با فروش',
      for: 'برای تیم‌های بزرگ',
      priceTip: 'فقط صورتحساب سالیانه',
    },
    community: {
      features: {
        0: 'تمام ویژگی‌های اصلی منتشر شده در مخزن عمومی',
        2: 'با رعایت مجوز منبع باز دیفی',
        1: 'فضای کاری واحد',
      },
      btnText: 'شروع کنید با جامعه',
      price: 'رایگان',
      includesTitle: 'ویژگی‌های رایگان:',
      description: 'برای کاربران فردی، تیم‌های کوچک یا پروژه‌های غیر تجاری',
      name: 'جامعه',
      for: 'برای کاربران فردی، تیم‌های کوچک یا پروژه‌های غیر تجاری',
    },
    premium: {
      features: {
        1: 'محل کار واحد',
        0: 'قابل اطمینان خودمدیریتی توسط ارائه‌دهندگان مختلف ابر',
        2: 'شعار و سفارشی‌سازی برند وب‌اپلیکیشن',
        3: 'پشتیبانی اولویت ایمیل و چت',
      },
      btnText: 'گرفتن نسخه پریمیوم در',
      description: 'برای سازمان‌ها و تیم‌های میان‌رده',
      price: 'قابل گسترش',
      includesTitle: 'همه چیز از جامعه، به علاوه:',
      for: 'برای سازمان‌ها و تیم‌های میان‌رده',
      name: 'پیشرفته',
      priceTip: 'بر اساس بازار ابری',
      comingSoon: 'پشتیبانی مایکروسافت آژور و گوگل کلود به زودی در دسترس خواهد بود',
    },
  },
  vectorSpace: {
    fullTip: 'فضای وکتور پر است.',
    fullSolution: 'طرح خود را ارتقاء دهید تا فضای بیشتری دریافت کنید.',
  },
  apps: {
    fullTipLine1: 'طرح خود را ارتقاء دهید تا',
    fullTipLine2: 'اپلیکیشن‌های بیشتری بسازید.',
    fullTip2: 'محدودیت طرح به پایان رسید',
    contactUs: 'با ما تماس بگیرید',
    fullTip1: 'به‌روزرسانی کنید تا برنامه‌های بیشتری ایجاد کنید',
    fullTip1des: 'شما به محدودیت ساخت برنامه‌ها در این طرح رسیده‌اید',
    fullTip2des: 'توصیه می‌شود برنامه‌های غیرفعال را پاک کنید تا فضای استفاده را آزاد کنید، یا با ما تماس بگیرید.',
  },
  annotatedResponse: {
    fullTipLine1: 'طرح خود را ارتقاء دهید تا',
    fullTipLine2: 'مکالمات بیشتری را حاشیه‌نویسی کنید.',
    quotaTitle: 'سهمیه پاسخ حاشیه‌نویسی',
  },
  usagePage: {
    documentsUploadQuota: 'حجم بارگذاری اسناد',
    vectorSpace: 'ذخیره‌سازی داده‌های دانش',
    teamMembers: 'اعضای تیم',
    annotationQuota: 'سهام حاشیه',
    buildApps: 'ساخت برنامه ها',
    vectorSpaceTooltip: 'سندهایی که با حالت نمایه‌سازی با کیفیت بالا تهیه می‌شوند، منابع ذخیره‌سازی داده‌های دانش را مصرف خواهند کرد. زمانی که ذخیره‌سازی داده‌های دانش به حد خود برسد، اسناد جدید بارگزاری نخواهند شد.',
  },
  teamMembers: 'اعضای تیم',
}

export default translation
